import { MarketplaceSoldsLink } from "@/components/market/MarketplaceSoldsLink";
import type { AltSoldsSearch } from "@/lib/scan/altSolds";

/** Opens ALT sold history for the selected grade; requires an ALT login. */
export function AltSoldsLink(props: {
  search: AltSoldsSearch;
  testID: string;
  /** Public pages disable authenticated analytics. */
  track?: boolean;
  /** Web only: compact layout inside the sales table. */
  inline?: boolean;
}) {
  return <MarketplaceSoldsLink {...props} />;
}
